import React from 'react'
import { EditCushionChargePolicyFlowProvider } from './context/EditCushionChargePolicyFlowProvider'
import { EditCushionChargePolicyFlowMain } from './components/EditCushionChargePolicyFlowMain'
import { useCushionChargePoliciesWorkflowsContextValue } from '../../context/CushionChargePoliciesWorkflowsProvider'

export const EditCushionChargePolicyFlow = () => {
  const { editCushionChargePolicyFlow } =
    useCushionChargePoliciesWorkflowsContextValue()

  if (!editCushionChargePolicyFlow.policy) {
    return null
  }

  return (
    <EditCushionChargePolicyFlowProvider>
      <EditCushionChargePolicyFlowMain
        policy={editCushionChargePolicyFlow.policy}
      />
    </EditCushionChargePolicyFlowProvider>
  )
}
